package com.trevorwiebe.timesheet.calendar.presentation

import com.trevorwiebe.timesheet.calendar.presentation.uiHelper.CalendarType
import com.trevorwiebe.timesheet.calendar.presentation.uiHelper.DayUi
import com.trevorwiebe.timesheet.calendar.presentation.uiHelper.TimeOffRequestUi
import com.trevorwiebe.timesheet.core.domain.model.DatabaseUserModel
import com.trevorwiebe.timesheet.core.domain.model.UserRole

data class CalendarState(
    val calendarStructure: List<DayUi> = emptyList(),
    val calendarType: CalendarType = CalendarType.GRID,
    val addingTimeOff: Boolean = false,
    val timeOffMode: Boolean = false,
    val user: DatabaseUserModel? = null,
    val userList: List<DatabaseUserModel> = emptyList(),
    val timeOffModel: TimeOffRequestUi? = null,
) {
    val isAdmin: Boolean = user?.role == UserRole.ADMIN

    // Non-admins get the existing delete confirmation for their own request; admins get the
    // approve/deny/delete review dialog for any request.
    val showTimeOffDialog = timeOffModel != null && !isAdmin
    val showReviewDialog = timeOffModel != null && isAdmin
}
